// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://scrollscan.com/address/0x69850D0B276776781C063771b161bd8894BCdD04
export const POOL_ADDRESSES_PROVIDER = '0x69850D0B276776781C063771b161bd8894BCdD04';

// IPool https://scrollscan.com/address/0x11fCfe756c05AD438e312a7fd934381537D3cFfe
export const POOL = '0x11fCfe756c05AD438e312a7fd934381537D3cFfe';

// IPoolConfigurator https://scrollscan.com/address/0x32BCab42a2bb5AC577D24b425D46d8b8e0Df9b7f
export const POOL_CONFIGURATOR = '0x32BCab42a2bb5AC577D24b425D46d8b8e0Df9b7f';

// IAaveOracle https://scrollscan.com/address/0x04421D8C506E2fA2371a08EfAaBf791F624054F3
export const ORACLE = '0x04421D8C506E2fA2371a08EfAaBf791F624054F3';

// https://scrollscan.com/address/0xfD0Ba55775C1e53f50736FA5528d8aa45FBcA391
export const PRICE_ORACLE_SENTINEL = '0xfD0Ba55775C1e53f50736FA5528d8aa45FBcA391';

// https://scrollscan.com/address/0xc1ABF87FfAdf4908f4eC8dc54A25DCFEabAE4A24
export const ACL_ADMIN = '0xc1ABF87FfAdf4908f4eC8dc54A25DCFEabAE4A24';

// IACLManager https://scrollscan.com/address/0x7633F981D87dC6307227de9383D2ce7243158081
export const ACL_MANAGER = '0x7633F981D87dC6307227de9383D2ce7243158081';

// IPoolDataProvider https://scrollscan.com/address/0xBEa2B648f05887eCbF1d115da8b7E4A317975A51
export const AAVE_PROTOCOL_DATA_PROVIDER = '0xBEa2B648f05887eCbF1d115da8b7E4A317975A51';

// https://scrollscan.com/address/0x354d1BA411708BC19Fc24DDAc98500B527048DEB
export const POOL_IMPL = '0x354d1BA411708BC19Fc24DDAc98500B527048DEB';

// https://scrollscan.com/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://scrollscan.com/address/0xa3f3100C4f1D0624DB9DB97b40C13885Ce297799
export const DEFAULT_INCENTIVES_CONTROLLER = '0xa3f3100C4f1D0624DB9DB97b40C13885Ce297799';

// https://scrollscan.com/address/0x6091546836DAe0487A50E300da3F237727441D90
export const EMISSION_MANAGER = '0x6091546836DAe0487A50E300da3F237727441D90';

// ICollector https://scrollscan.com/address/0x90eB541e1a431D8a30ED85A77675D1F001128cb5
export const COLLECTOR = '0x90eB541e1a431D8a30ED85A77675D1F001128cb5';

// https://scrollscan.com/address/0x67D758F837f2660D76b90D820aAddE54aA7eB062
export const DEFAULT_A_TOKEN_IMPL = '0x67D758F837f2660D76b90D820aAddE54aA7eB062';

// https://scrollscan.com/address/0xA8A5F4cF847F945e2535b9A733F14B018931713E
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xA8A5F4cF847F945e2535b9A733F14B018931713E';

// https://scrollscan.com/address/0x8714E5ED2d8edD4E88eFf66637C3FE8eCf2B8C40
export const L2_ENCODER = '0x8714E5ED2d8edD4E88eFf66637C3FE8eCf2B8C40';

// https://scrollscan.com/address/0x0451f67bA61966C346daBAbB50a30Cc6A9A67C69
export const RISK_STEWARD = '0x0451f67bA61966C346daBAbB50a30Cc6A9A67C69';

// https://scrollscan.com/address/0xF487B5787f79e2284BA755F094F1F8fEB17B5E79
export const CONFIG_ENGINE = '0xF487B5787f79e2284BA755F094F1F8fEB17B5E79';

// https://scrollscan.com/address/0xFBedc64AeE24921cb43004312B9eF367a4162b57
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0xFBedc64AeE24921cb43004312B9eF367a4162b57';

// https://scrollscan.com/address/0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16
export const UI_INCENTIVE_DATA_PROVIDER = '0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16';

// https://scrollscan.com/address/0x6926c8195a8840099Daa643C2d9aDE18C0D233d9
export const UI_POOL_DATA_PROVIDER = '0x6926c8195a8840099Daa643C2d9aDE18C0D233d9';

// https://scrollscan.com/address/0xE51642875Af07Fea1B03d821E41a9DB24bC4447E
export const WALLET_BALANCE_PROVIDER = '0xE51642875Af07Fea1B03d821E41a9DB24bC4447E';

// https://scrollscan.com/address/0xE79Ca44408Dae5a57eA2a9594532f1E84d2edAa4
export const WETH_GATEWAY = '0xE79Ca44408Dae5a57eA2a9594532f1E84d2edAa4';

// https://scrollscan.com/address/0xD1aE9Da215B06910F246b13fbCbd74D9657AF365
export const DUST_BIN = '0xD1aE9Da215B06910F246b13fbCbd74D9657AF365';

// https://scrollscan.com/address/0x7616355B00c9d1D2Faf3937Dacb5B9aA1e6755de
export const CLINIC_STEWARD = '0x7616355B00c9d1D2Faf3937Dacb5B9aA1e6755de';

// https://scrollscan.com/address/0xf4c8A85fee25f055795E5DcDF39b447aD5761aC7
export const POOL_EXPOSURE_STEWARD = '0xf4c8A85fee25f055795E5DcDF39b447aD5761aC7';

// https://scrollscan.com/address/0x01cfB64B99f717d791260ECb502e675d6E8Cf522
export const STATA_FACTORY = '0x01cfB64B99f717d791260ECb502e675d6E8Cf522';

export const CHAIN_ID = 534352;
export const ASSETS = {
  WETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x5300000000000000000000000000000000000004',
    A_TOKEN: '0xf301805bE1Df81102C957f6d4Ce29d2B8c056B2a',
    V_TOKEN: '0xfD7344CeB1Df9Cf238EcD667f4A6F99c6Ef44a56',
    INTEREST_RATE_STRATEGY: '0xC37353E5766164D8654D3CB395acfDcA4c2E7Ddc',
    ORACLE: '0x6bF14CB0A831078629D993FDeBcB182b21A8774C',
  },
  USDC: {
    decimals: 6,
    id: 1,
    UNDERLYING: '0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4',
    A_TOKEN: '0x1D738a3436A8C49CefFbaB7fbF04B660fb528CbD',
    V_TOKEN: '0x3d2E209af5BFa79297C88D6b57F89d792F6E28EE',
    INTEREST_RATE_STRATEGY: '0xC37353E5766164D8654D3CB395acfDcA4c2E7Ddc',
    ORACLE: '0x1685D81212580DD4cDA287616C2f6F4794927e18',
  },
  wstETH: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0xf610A9dfB7C89644979b4A0f27063E9e7d7Cda32',
    A_TOKEN: '0x5B1322eeb46240b02e20062b8F0F9908d525B09c',
    V_TOKEN: '0x8a035644322129800C3f747f54Db0F4d3c0A2877',
    INTEREST_RATE_STRATEGY: '0xC37353E5766164D8654D3CB395acfDcA4c2E7Ddc',
    ORACLE: '0x4EdAbf45e78363b8Dcd763bBbd05665c6e24975C',
  },
  weETH: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0x01f0a31698C4d065659b9bdC21B3610292a1c506',
    A_TOKEN: '0xd80A5e16DBDC52Bd1C947CEDfA22c562Be9129C8',
    V_TOKEN: '0x009D88C6a6B4CaA240b71C98BA93732e26F2A55A',
    INTEREST_RATE_STRATEGY: '0xC37353E5766164D8654D3CB395acfDcA4c2E7Ddc',
    ORACLE: '0x32f924C0e0F1Abf5D1ff35B05eBc5E844dEdD2A9',
  },
  SCR: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0xd29687c813D741E2F938F4aC377128810E217b1b',
    A_TOKEN: '0x25718130C2a8eb94e2e1FAFB5f1cDd4b459aCf64',
    V_TOKEN: '0xFFbA405BBF25B2e6C454d18165F2fd8786858c6B',
    INTEREST_RATE_STRATEGY: '0xC37353E5766164D8654D3CB395acfDcA4c2E7Ddc',
    ORACLE: '0x26f6F7C468EE309115d19Aa2055db5A74F8cE7A5',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'WETH,wstETH,weETH / WETH',
    collateralBitmap: '13',
    collateralAssets: [
      '0x5300000000000000000000000000000000000004',
      '0xf610A9dfB7C89644979b4A0f27063E9e7d7Cda32',
      '0x01f0a31698C4d065659b9bdC21B3610292a1c506',
    ],
    borrowableBitmap: '1',
    borrowableAssets: ['0x5300000000000000000000000000000000000004'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9300,
    liquidationBonus: 10100,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
